/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */
export const SHOP_AS_USER_PARAM = 'shopAsUser';
